import { geoPath } from 'd3-geo';

/**
 * A pre-defined GeoPath for calling bounds with.
 * @private
 */
const path = geoPath();

/**
 * Takes a GeoJSON object and a d3 GeoPath and calculates the ratio of the
 * width to the height.
 *
 * @param {import('d3-geo').GeoPermissibleObjects} geojson A GeoJSON object
 */
export default function calculateHeightRatio(geojson) {
  const bounds = path.bounds(geojson);
  return (bounds[1][1] - bounds[0][1]) / (bounds[1][0] - bounds[0][0]);
}
